<template>
  <div class="drawer-wrapper">
    <el-drawer
        :title="title"
        :wrapperClosable="false"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :size="size"
        :before-close="handleClose"
    >
      <div class="demo-drawer__content">
        <slot></slot>
      </div>

      <div class="demo-drawer__footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    title: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '50%'
    },
    visible: {
      type: Boolean,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    },
    onConfirm: {
      type: Function,
      required: true
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    handleClose(done) {
      this.handleCancel();
      done();
    },
    handleCancel() {
      this.onCancel();
    },
    handleConfirm() {
      this.onConfirm();
    }
  }
};
</script>

<style lang="scss" scoped>
.demo-drawer__content {
  height: calc(100% - 80px);
  overflow-y: auto;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;

  .el-button {
    margin: 0 10px;
    width: calc(50% - 20px);
  }
}
</style>